import StickySidebar from 'sticky-sidebar';
export function stickySidebar() {
  const sidebar = document.querySelectorAll('.js-sticky-sidebar-container');
  if(sidebar.length) {
    for (let i = 0; i < sidebar.length; i++) {
      const el = sidebar[i];
      const bar = el.querySelector('.js-sticky-sidebar');
      window.addEventListener('load', () => {
        const stickySidebar = new StickySidebar(el, {
          topSpacing: 50,
          bottomSpacing: 50,
          containerSelector: '.js-sticky-sidebar-container',
          innerWrapperSelector: '.js-sticky-sidebar'
        });
        setInterval( () => {
          stickySidebar.updateSticky();
        }, 1000)
        window.addEventListener('resize', () => {
          if(bar) bar.removeAttribute('style');
          stickySidebar.updateSticky();
        });
        window.addEventListener('orientationchange', () => {
          if(bar) bar.removeAttribute('style');
          stickySidebar.updateSticky();
        });
        stickySidebar.updateSticky();
      });
    }
  }
}